import type { FaireProductEntity } from "../../entity_types/product";

export const p_78kqz3bu74: FaireProductEntity = {
  token: "p_78kqz3bu74",
  type: "product",
  name: "Adjustable cross necklace, stainless steel, 18K gold plated",
  brandToken: "b_3t5pew5dxb",
  brandName: "Minimalistajoyeria",
  imageUrl:
    "https://cdn.faire.com/fastly/ed9d00212eb22121bc294bf32732f135b72d82ada8cbb6d8c5804b75e3dc7c16.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8e9fb592a03ef666d12925f4cf29da5b7395de8b4b20f79d3ea0e8af1f10cf45.jpeg",
    "https://cdn.faire.com/fastly/3e5fe3733069b1dc28293ad57eb3180493f127db9ba1088fa42d89707a380ae9.jpeg",
  ],
  priceDollars: 3.51,
  description:
    "Premium Material: Stainless steel with 18K gold vacuum plating (PVD waterproof); water-resistant, durable, and does not tarnish.  \nFinish: Polished shine  \nHypoallergenic: Safe for sensitive skin; does not stain or irritate.  \nLength: 40cm plus 5cm extension with two models to choose from  \n\nStock in Spain: Fast shipping and no customs.  \n\nDirect Price: Luxury aesthetics at factory price.",
  tags: [],
  msrpDollars: 12.45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:29.731Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
